<template>
  <v-layout row wrap fill-height align-content-space-between>
    <YesNoModal ref="YesNoModal" />
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-toolbar dense dark>
        <v-toolbar-title>Inspection - Allocate</v-toolbar-title>
      </v-toolbar>
      <v-form @submit.prevent="AllocateInspection" ref="form">
        <v-container>
          <v-layout row wrap justify-center>
            <v-flex xs11 md6>
              <v-select label="Customer" :items="CustomerList" item-text="Name" item-value="ID"
                v-model="SelectedCustomerID"></v-select>
              <v-select label="Customer Venue" :items="CustomerVenueList" item-text="Name" item-value="ID"
                :disabled="SelectedCustomerID == null" v-model="form.CustomerVenueID"></v-select>
              <v-select label="Customer Inspection" :items="CustomerInspectionList" item-text="Name" item-value="ID"
                :disabled="form.CustomerVenueID == null" v-model="form.CustomerInspectionID"></v-select>
              <v-text-field label="Reference" v-model="form.Reference"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-list>
                <v-list-group v-for="item in SelectedInspection" :key="item.ID" no-action>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.CustomerInspection.Name }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-spacer></v-spacer>
                      <!-- <v-btn @click.stop="addNewInspectionItem(item)" icon color="success" outline>
                        <v-icon>mdi-plus</v-icon>
                      </v-btn> -->
                    </v-list-tile>
                  </template>

                  <v-list-tile v-for="subItem in item.CustomerInspectionItems" :key="subItem.ID">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.Name }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>

    <v-flex x12>
      <v-layout row justify-center>
        <v-flex xs10 md6>
          <v-btn color="success" block @click="AllocateInspection">Allocate</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-dialog v-model="InspectionItemDialog">
      <v-card>
        <v-toolbar dense dark>
          <v-toolbar-title>{{SingleSelectedCustomer.CustomerInspection.Name}} - New Inspection Item</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-form ref="InspectionItemForm">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="InspectionItemForm.Name" label="Name"></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="SaveNewInspectionItem">Save</v-btn>
              <v-btn color="success" @click="CancelNewInspectionItem">Cancel</v-btn>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import JWT from "jsonwebtoken";
  import supervisorMW from "@/libs/middleware/supervisorMW";

  export default {
    data() {
      return {
        dialog: false,
        InspectionItemDialog: false,
        CustomerList: [],
        IDBVenueList: [],
        IDBInspectionList: [],
        IDBInspectionItemList: [],
        CustomerVenueList: [],
        CustomerInspectionList: [],
        CustomerInspections: [],
        SystemUserList: [],
        SelectedCustomerID: null,
        SelectedInspection: [],
        form: {
          SystemUserID: null,
          CustomerVenueID: null,
          CustomerInspectionID: null,
          DateTime: null,
          Reference: null
        },
        InspectionItemForm: {
          CustomerInspectionID: null,
          Name: null
        },
        SingleSelectedCustomer: {
          CustomerInspection: {},
          CustomerInspectionItems: []
        },
        InspecToPush: {},
      };
    },
    watch: {
      SelectedCustomerID() {
        this.fetchCustomerVenues();
      },
      "form.CustomerVenueID"() {
        this.fetchCustomerInspections();
      },
      "form.CustomerInspectionID"() {
        this.GetInspectionItems();
      }
    },
    mounted() {
      let self = this;
      let sessionData = self.$store.getters.getUserSessionData;
      let tokenDecoded = JWT.decode(sessionData.AccessToken);

      self.form.SystemUserID = tokenDecoded.USER_ID;

      let storeData = self.$store.getters.getLastCheckInData;

      if (storeData.VenueID != null) {
        self.form.CustomerVenueID = storeData.VenueID;
      }

      if (storeData.CustomerID != null) {
        self.SelectedCustomerID = storeData.CustomerID;
      }

      //this.fetchCustomers();

      self.FetchUserData();
    },
    methods: {
      FetchUserData() { // indexed db
        let self = this;
        let mw = new supervisorMW(self);

        mw.GetUserData().then(r => {
          console.log("[USER DATA]", r[0]);

          r[0].CustomerList.forEach(customer => {
            self.CustomerList.push(customer.Customer); // CUSTOMER LIST

            customer.Venues.forEach(venue => {
              self.IDBVenueList.push(venue.CustomerVenue);

              venue.Inspections.forEach(inspection => {
                self.IDBInspectionList.push(inspection);
              })
            })
          })
        })
        console.log("[VENUE LIST]", self.IDBVenueList)
        console.log("[INSPECTION LIST]", self.IDBInspectionList);
      },
      fetchCustomers() {
        let self = this;
        let systemUserID = self.form.SystemUserID;
        self
          .get(`Customer/GetBySystemUser?systemUserID=${systemUserID}`)
          .then(r => {
            self.CustomerList = r.data;
          });
      },
      fetchCustomerVenues() {
        let self = this;
        let customerID = self.SelectedCustomerID;
        self.CustomerVenueList = [];
        let mw = new supervisorMW(self);

        mw.GetUserData().then(r => {
          console.log("[USER DATA - SELECTED CUSTOMER]", r[0]);

          self.CustomerVenueList = self.IDBVenueList.filter(venue => {
            return venue.CustomerID == customerID;
          })

          console.log("[FILTERED VENUES]", self.CustomerVenueList);
        })
      },
      fetchCustomerInspections() {
        let self = this;
        let customerID = self.SelectedCustomerID;
        let customerVenueID = self.form.CustomerVenueID;
        self.CustomerInspectionList = [];
        let mw = new supervisorMW(self);

        mw.GetUserData().then(r => {
          console.log("[USER DATA - SELECTED CUSTOMER]", r[0]);

          var filters = self.IDBInspectionList.filter(inspection => {
            return inspection.CustomerInspection.CustomerVenueID == customerVenueID;
          })

          filters.forEach(item => {
            self.CustomerInspectionList.push(item.CustomerInspection);
          })
          console.log("[FILTERED INSPECTIONS]", self.CustomerInspectionList);
        })
      },
      GetInspectionItems() {
        let self = this;
        let inspectionID = self.form.CustomerInspectionID;
        let mw = new supervisorMW(self);

        mw.GetUserData().then(r => {
          console.log("[USER DATA]", r[0]);

          r[0].CustomerList.forEach(customer => {
            customer.Venues.forEach(venue => {

              venue.Inspections.forEach(inspection => {
                inspection.InspectionItems.forEach(el => {
                  self.IDBInspectionItemList.push(el);
                })
              })
            })
          })
        })

        setTimeout(() => {
          var inspection = self.IDBInspectionList.filter(inspection => {
            console.log('inspections', inspection)
            return inspection.CustomerInspection.ID == inspectionID;
          })
          var items = self.IDBInspectionItemList.filter(item => {
            return item.CustomerInspectionID == inspectionID;
          })

          var inspectionToPush = {
            CustomerInspection: inspection[0].CustomerInspection,
            CustomerInspectionItems: items
          }
          self.InspecToPush = inspectionToPush;;
          //self.SelectedInspection.push(inspectionToPush);
          console.log("[SELECTED INSPECTION]", self.SelectedInspection)
        }, 200)
      },
      addNewInspectionItem(item) {
        let self = this;

        self.SingleSelectedCustomer = item;
        self.InspectionItemForm.CustomerInspectionID = item.CustomerInspection.ID;
        self.InspectionItemDialog = true;
      },
      SaveNewInspectionItem() {
        let self = this;
        let request = self.InspectionItemForm;
        self.post(`CustomerInspections/PostInspectionItem`, request).then(r => {
          self.SingleSelectedCustomer.CustomerInspectionItems.push(r.data);
          self.InspectionItemDialog = false;
          self.$refs.InspectionItemForm.reset();
        });
      },
      CancelNewInspectionItem() {
        let self = this;

        self.InspectionItemDialog = false;
        self.$refs.InspectionItemForm.reset();
      },
      guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      AllocateInspection() {
        let self = this;
        let mw = new supervisorMW(self);
        
        let request = this.form;
        request.UID = Math.floor(Math.random() * 101);;
        console.log("[REQUEST]", request)

        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Allocating Inspection...");

        mw.AllocateInspection(self.form.SystemUserID, request).then(r => {
          self.$refs.Loader.hide();
          self.$refs.YesNoModal.show(
            "Allocation Successful! \r\n Would you like to allocate another inspection",
            function (yes) {
              if (yes == true) {
                self.SelectedInspection.push(self.InspecToPush)
                self.$refs.form.reset();
              } else {
                let checkInData = self.$store.getters.getLastCheckInData;

                if (checkInData.VenueID != null) {
                  self.$router.push(
                    `/Supervisor/Inspections/Allocated/${checkInData.VenueID}`
                  );
                } else {
                  self.$router.push(
                    `/Supervisor/Customers`
                  );
                }
              }
            })
        })
      }
    }
  };
</script>

<style>
</style>